import React from 'react'
import {Input, Modal, Row, Col, Form, FormGroup, Label} from "reactstrap";
import Select from "react-select"
import DropImage from "../../components/DropImage"

const render_rows = (tog_standard, modal_standard, product, onChangeInput, shareStock, branches) => {
    if(!product) return "";

    const { name, code, sku, price, color, size, units, share_qty, from, share } = product;

    return (
      <Modal
        size="xl"
        isOpen={modal_standard}
        toggle={() => tog_standard('share')}
      >
          <div className="modal-header">
              <h5 className="modal-title mt-0" id="myModalLabel">
                  Compartir stock
              </h5>
              <button type="button"
                      onClick={() => tog_standard('share')}
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
              >
                  <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div className="modal-body">
              <Form>
                  <Row>
                      <Col sm="4">
                          <FormGroup>
                              <Label htmlFor="bundle_qty">Nombre</Label>
                              <Input type="text" className="form-control" defaultValue={ name } disabled={true} />
                          </FormGroup>
                      </Col>
                      <Col sm="4">
                          <FormGroup>
                              <Label htmlFor="bundle_qty">Codigo</Label>
                              <Input type="text" className="form-control" defaultValue={ code } disabled={true} />
                          </FormGroup>
                      </Col>
                      <Col sm="4">
                          <FormGroup>
                              <Label htmlFor="bundle_qty">SKU</Label>
                              <Input type="text" className="form-control" defaultValue={ sku } disabled={true} />
                          </FormGroup>
                      </Col>
                      <Col sm="4">
                          <FormGroup>
                              <Label htmlFor="bundle_qty">Precio</Label>
                              <Input type="text" className="form-control" defaultValue={ price } disabled={true} />
                          </FormGroup>
                      </Col>
                      <Col sm="4">
                          <FormGroup>
                              <Label htmlFor="bundle_qty">Color</Label>
                              <Input type="text" className="form-control" defaultValue={ color } disabled={true} />
                          </FormGroup>
                      </Col>
                      <Col sm="4">
                          <FormGroup>
                              <Label htmlFor="bundle_qty">Talle</Label>
                              <Input type="text" className="form-control" defaultValue={ size } disabled={true} />
                          </FormGroup>
                      </Col>
                      <Col sm="4" xs="4">
                          <FormGroup>
                              <Label htmlFor="bundle_qty">Stock {branches[0].label}</Label>
                              <Input type="text" className="form-control" defaultValue={ units[0] } disabled={true} />
                          </FormGroup>
                      </Col>
                      <Col sm="4" xs="4">
                          <FormGroup>
                              <Label htmlFor="bundle_qty">Mover</Label>
                              <Input type="number" className="form-control" value={ share } onChange={ e => {onChangeInput(Number(e.target.value), 'share')} }/>
                          </FormGroup>
                      </Col>
                      <Col sm="4" xs="4">
                          <FormGroup>
                              <Label htmlFor="bundle_qty">Stock {branches[1].label}</Label>
                              <Input type="text" className="form-control" defaultValue={ units[1] } disabled={true} />
                          </FormGroup>
                      </Col>
                      <Col sm="4" xs="4">
                          <FormGroup>
                              <Label htmlFor="bundle_qty">Nuevo stock {branches[0].label}</Label>
                              <Input type="text" className="form-control" value={ share_qty[0] } disabled={true} />
                          </FormGroup>
                      </Col>
                      <Col sm="4" xs="4" style={{textAlign: 'center'}}>
                          <i onClick={() => onChangeInput(null, 'from')} style={{ fontSize: "32px", marginTop: '28px' }} className={`bx bx-${from === 0 ? 'bx bx-right-arrow': 'bx bx-left-arrow'}`}/>
                      </Col>
                      <Col sm="4" xs="4">
                          <FormGroup>
                              <Label htmlFor="bundle_qty">Nuevo stock {branches[1].label}</Label>
                              <Input type="text" className="form-control" value={ share_qty[1] } disabled={true} />
                          </FormGroup>
                      </Col>
                  </Row>
              </Form>
          </div>
          <div className="modal-footer">
              <button
                type="button"
                onClick={() => tog_standard('share')}
                className="btn btn-secondary waves-effect"
                data-dismiss="modal"
              >
                  Cancelar
              </button>
              <button
                type="button"
                onClick={shareStock}
                className="btn btn-primary waves-effect waves-light"
                data-dismiss="modal"
              >
                  Actualizar
              </button>
          </div>
      </Modal>
    );
}

const ModalShare = ({tog_standard, modal_standard, product, onChangeInput, shareStock, branches}) => (
  render_rows(tog_standard, modal_standard, product, onChangeInput, shareStock, branches)
)

export default ModalShare
